import { AppProvider } from '@shopify/polaris';
import React from 'react';
import { ApolloClient } from '@apollo/client/core';
import { createHttpLink } from 'apollo-link-http';
import envConfig from '@nile/home/src/Config/env';
import {
  getHeaderValue,
  BrandingLogo,
  getCookieValue,
  ERROR_CODES,
  toast,
  EventEmitter
} from '@nile/components';
import { InMemoryCache } from '@apollo/client/cache';
import ArticleReader from '../../components/ArticleSearchSheet/ArticleReader';
import { onError } from '@apollo/client/link/error';
import hashHistory from '@nile/home/src/hashHistory';
import { loggerInfo } from '@nile/home/src/coralogixRUM';

const cache = new InMemoryCache({
  addTypename: false
});

const errorLink = onError((params) => {
  const { graphQLErrors, networkError, operation, forward } = params;
  const context = operation.getContext();
  const { headers, serviceName } = context;
  var timerId;

  const isDevEnv = ['development', 'alpha'].includes(process.env.NODE_ENV);

  const info = {
    hrefString: location.href,
    userAgent: navigator.userAgent,
    id: getCookieValue('uitoken'),
    headers: headers,
    query: operation?.query?.loc?.source?.body,
    variables: operation?.variables
  };

  if (graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
    switch (graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
      case 568: // ITEM DELETED
        hashHistory.push('/error/itemNotFound', { errors: networkError });
        break;
      case 403:
        hashHistory.push('/error/restrictedAccess', { errors: networkError });
        break;
      default:
        {
          const errCode = graphQLErrors[0].extensions.clientError[0].errorCode;
          const errorMessage =
            ERROR_CODES[errCode] || `app.errorCode.${errCode}`;
          toast('error', errorMessage);
        }

        break;
    }
  } else if (networkError) {
    switch (networkError?.statusCode) {
      case 503:
        EventEmitter.dispatch('serviceUnavailableError', {
          serviceName: serviceName
        });
        break;
      case 520:
        if (networkError?.result) {
          if (networkError?.result?.error?.includes('Under Maintenance')) {
            if (window.location.hash !== '#/error/underMaintenance')
              window.localStorage.setItem(
                'previousRoute',
                JSON.stringify({
                  route: window.location.hash,
                  maintenance: true
                })
              );
            if (timerId) {
              clearTimeout(timerId);
            }
            timerId = setTimeout(
              () =>
                hashHistory.push('/error/underMaintenance', {
                  errors: networkError
                }),
              3000
            );
          }
        } else {
          if (window.location.hash !== '#/error/underMaintenance')
            window.localStorage.setItem(
              'previousRoute',
              JSON.stringify({
                route: window.location.hash,
                maintenance: true
              })
            );
          if (timerId) {
            clearTimeout(timerId);
          }
          timerId = setTimeout(
            () =>
              hashHistory.push('/error/underMaintenance', {
                errors: networkError
              }),
            3000
          );
        }
        break;
      case 403:
        hashHistory.push('/error/restrictedAccess', { errors: networkError });
        break;
      case 551: // PASSWORD_EXPIRED
        hashHistory.push('/error/passwordExpired', { errors: networkError });
        break;
      case 568: // ITEM DELETED
        hashHistory.push('/error/itemNotFound', { errors: networkError });
        break;
      default:
        break;
    }
  }

  if (isDevEnv && networkError?.statusCode) {
    toast('error', `Network Error: ${networkError.statusCode}`);
  }

  if (isDevEnv && graphQLErrors) {
    let apiName =
      params?.operation?.operationName ??
      Object.keys(params?.response?.data ?? {})[0];
    apiName = apiName ? `${apiName} : ` : '';
  }

  function extractQueryName(inputString) {
    if (!inputString) {
      return null;
    }

    const trimmed = inputString.replace(/\s+/g, ' ').trim();

    const match = trimmed.match(/{\s*(\w+)/);
    return match ? match[1] : null;
  }

  if (networkError) {
    const queryName = extractQueryName(info?.query);
    info.queryName = queryName;
    info.apiDomain = localStorage?.getItem('apiDomain');
    info.dcRegion = localStorage?.getItem('dcRegion');
  }

  // if (window?.logger) {
  //   logger.info('Network graphql request', {
  //     graphQLErrors,
  //     networkError,
  //     info
  //   });
  //   logger.flush();
  // }
  loggerInfo('Network graphql request', {
    graphQLErrors,
    networkError,
    info
  });
});

function ArticlePublicPage(props) {
  const params = new URLSearchParams(props.location.search);
  const articleId = params.get('entityId');
  const token = params.get('token');
  const AccountClient = new ApolloClient({
    cache,
    link: errorLink.concat(
      createHttpLink({
        uri: localStorage?.getItem('apiDomain') + envConfig.accountsGateway,
        credentials: 'include',
        headers: {
          ...getHeaderValue(),
          authorization: `Bearer nl-${token}`
        }
      })
    ),
    connectToDevTools: true
  });
  return (
    <AppProvider>
      <div className="flex fcol mx-auto mt30 mb-30 mw-letter full-height full-width-vw">
        <div className="flex-center">
          <BrandingLogo />
        </div>
        <div className="h95">
          <ArticleReader
            selectedArticle={{ id: articleId }}
            ApiClient={AccountClient}
            token={token}
            hideActions
            hideToolBar
          />
        </div>
      </div>
    </AppProvider>
  );
}

export default ArticlePublicPage;
